<div class="main-content">
  <div class="main-header">
    <a [routerLink]="['/cloud-load']" style="cursor: pointer;"><img
      src="./assets/Expand-Column-left.svg" alt="Image 1" class="r-m20" style="vertical-align: middle;" /></a>
    Cloud Load Configurations <div class="tooltip"><img src="./assets/Info.svg" alt="Image 1" /><span
    class="tooltiptext">Cloud Load feature allows us to select and load multiple configurations across modules sequentially in oracle cloud instance based on inbuilt dependencies , provides
    detailed error reporting and track configuration quality thus enabling project teams to concentrate on value add activities.</span></div> 
  
  </div>
  <div class="">
    <div style="margin-bottom: 20px ;">
      <app-progress-bar [indexItem]=itemNumber [progressBarState]=progressBarName [progressBarArray1]=progressBarArray1>
      </app-progress-bar>
    </div>
  </div>
  <div style="margin-top: 10px;">
    <router-outlet></router-outlet>
  </div>
</div>
